module.exports = __webpack_public_path__ + "img/12.e0b6711d.jpg";